import { render, staticRenderFns } from "./PoliticianAvatarRow.vue?vue&type=template&id=20af5daa&scoped=true"
import script from "./PoliticianAvatarRow.vue?vue&type=script&lang=js"
export * from "./PoliticianAvatarRow.vue?vue&type=script&lang=js"
import style0 from "./PoliticianAvatarRow.vue?vue&type=style&index=0&id=20af5daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20af5daa",
  null
  
)

export default component.exports